import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/** Up to two initials for an avatar: "Ada Lovelace" gives "AL". */
export function initials(name: string): string {
  const words = name.trim().split(/\s+/).filter(Boolean)
  if (words.length === 0) return "?"
  const first = words[0][0] ?? ""
  const last = words.length > 1 ? (words[words.length - 1][0] ?? "") : ""
  return (first + last).toUpperCase()
}

/**
 * Returns the path only if it is a same-origin app path, otherwise undefined.
 * Use for any redirect target read from the URL, so `?redirect=` can never
 * send someone to another site.
 */
export function safeRedirectPath(raw: string | undefined | null): string | undefined {
  if (!raw || !raw.startsWith("/") || raw.startsWith("//") || raw.includes("\\")) {
    return undefined
  }
  return raw
}
